module.exports = require("dyna-try");